/**
 * Normalize user input into a safe embed URL (YouTube / Vimeo / generic https).
 *
 * @param {Object} props
 * @param {string} props.iframe_url
 * @return {string}
 */
function sanitizeProtocol( url ) {
	if ( ! url || typeof url !== 'string' ) {
		return '';
	}
	try {
		const parsed = new URL( url.trim() );
		if ( parsed.protocol !== 'http:' && parsed.protocol !== 'https:' ) {
			return '';
		}
		return parsed.toString();
	} catch {
		return '';
	}
}

function getYoutubeVideoId( url ) {
	if ( ! url || typeof url !== 'string' ) {
		return null;
	}
	const regExp =
		/^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|shorts\/|watch\?v=|&v=)([^#&?]*).*/;
	const match = url.match( regExp );
	return match && match[ 2 ] && match[ 2 ].length === 11 ? match[ 2 ] : null;
}

function getVimeoVideoId( url ) {
	if ( ! url || typeof url !== 'string' ) {
		return null;
	}
	const regExp = /https?:\/\/(?:www\.)?vimeo\.com\/(\d+)(?:\/|$)/;
	const match = url.match( regExp );
	return match && match[ 1 ] ? match[ 1 ] : null;
}

export default function iframeUrl( { iframe_url } ) {
	const raw = iframe_url || '';
	let videoUrl = sanitizeProtocol( raw );
	if ( ! videoUrl ) {
		return '';
	}

	const youtubeVideoId = getYoutubeVideoId( videoUrl );
	const vimeoVideoId = getVimeoVideoId( videoUrl );

	if ( youtubeVideoId ) {
		videoUrl = `https://www.youtube.com/embed/${ youtubeVideoId }`;
	}
	if ( vimeoVideoId ) {
		videoUrl = `https://player.vimeo.com/video/${ vimeoVideoId }`;
	}

	return sanitizeProtocol( videoUrl );
}
